<script>
  export let errors;
  export let selectUnitsInfo;

  $: $errors && checkError();

  let generalError = false;
  let clientContactError = false;
  let clientTypeError = false;
  let registrationTypeError = false;
  let engagementTypeError = false;
  let usersError = false;
  let attachmentError = false;
  let fundProfileError = false;
  let otherInfoError = false;
  let serviceProviderError = false;

  const checkError = () => {
    generalError =
      $errors.name ||
      $errors.billingAddress ||
      $errors.street ||
      $errors.city ||
      $errors.state ||
      $errors.zip ||
      $errors.country;
    //contacts
    for (var i in $errors.contacts) {
      clientContactError =
        $errors.contacts[i].name ||
        $errors.contacts[i].email ||
        $errors.contacts[i].title ||
        $errors.contacts[i].phone;
      if (clientContactError) break;
    }

    //client
    for (var i in $errors.clientTypes) {
      clientTypeError = $errors.clientTypes[i].unitClientTypeId;
      if (clientTypeError) break;
    }

    //registration
    for (var i in $errors.registrationTypes) {
      registrationTypeError =
        $errors.registrationTypes[i].unitRegistrationTypeId ||
        $errors.registrationTypes[i].registrationNo ||
        $errors.registrationTypes[i].registrationUrl;
      if (registrationTypeError) break;
    }

    engagementTypeError = false;
    //engagement
    for (var i in $errors.projectTypes) {
      engagementTypeError =
        $errors.projectTypes[i].unitProjectTypeId || $errors.projectTypes[i].endDate;
      if (engagementTypeError) break;
    }
    if ($errors.ongoingEndDate || $errors.ongoingStartDate) {
      engagementTypeError = true;
    }
    for (var i in $errors.sows) {
      engagementTypeError = $errors.sows[i].unitSowId;
      if (engagementTypeError) break;
    }

    //users
    for (var i in $errors.users) {
      usersError = $errors.users[i].userId;
      if (usersError) break;
    }

    //attachments
    for (var i in $errors.urls) {
      attachmentError = $errors.urls[i].url;
      if (attachmentError) break;
    }

    //Fund Profile
    for (var i in $errors.fundProfiles) {
      fundProfileError =
        $errors.fundProfiles[i].name ||
        $errors.fundProfiles[i].unitFundStrategyId ||
        $errors.fundProfiles[i].ccc ||
        $errors.fundProfiles[i].pmac ||
        $errors.fundProfiles[i].cik ||
        $errors.fundProfiles[i].passphrase ||
        $errors.fundProfiles[i].password ||
        $errors.fundProfiles[i].renewal ||
        $errors.fundProfiles[i].renewalDate;

      for (var j in $errors.fundProfiles[i].blueskys) {
        if (
          $errors.fundProfiles[i].blueskys[j] != undefined &&
          $errors.fundProfiles[i].blueskys[j].date != '' &&
          $errors.fundProfiles[i].blueskys[j]
        ) {
          fundProfileError = true;
        }
      }
      if (fundProfileError) break;
    }

    //other Info
    otherInfoError = $errors.unitCodeEthicsId || $errors.ethicsOtherName;

    //Service Provider
    serviceProviderError;
    for (var i in $errors.serviceProviders) {
      serviceProviderError =
        $errors.serviceProviders[i].name ||
        $errors.serviceProviders[i].type ||
        $errors.serviceProviders[i].email ||
        $errors.serviceProviders[i].phone;
      if (serviceProviderError) break;
    }
  };
</script>

<div class=" d-flex flex-column add-client-left h-100 ps-3 pt-3">
  <div class=" page-content">
    <ul
      class="nav nav-pills"
      id="v-pills-tab"
      role="tablist"
      aria-orientation="vertical"
    >
      <li class={generalError ? 'error' : ''}>
        <a
          class="nav-link rounded-start active d-flex align-items-cente"
          id="v-pills-general-tab"
          data-bs-toggle="pill"
          href="#v-pills-general"
          role="tab"
          aria-controls="v-pills-general"
          aria-selected="true"
        >
          <div class="left-menu-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M13.8337 9.06666L12.6503 7.88333L9.11699 11.425L7.35033 9.65L6.16699 10.8333L9.11699 13.7833L13.8337 9.06666Z"
              />
              <path
                d="M15.8333 3.33334H4.16667C3.72464 3.33334 3.30072 3.50893 2.98816 3.82149C2.67559 4.13405 2.5 4.55797 2.5 5V15C2.5 15.442 2.67559 15.866 2.98816 16.1785C3.30072 16.4911 3.72464 16.6667 4.16667 16.6667H15.8333C16.75 16.6667 17.5 15.9167 17.5 15V5C17.5 4.55797 17.3244 4.13405 17.0118 3.82149C16.6993 3.50893 16.2754 3.33334 15.8333 3.33334ZM15.8333 15H4.16667V6.66667H15.8333V15Z"
              />
            </svg>
          </div>
          General
        </a>
      </li>
      <li class={clientContactError ? 'error' : ''}>
        <a
          class="nav-link rounded-start d-flex align-items-center"
          id="v-pills-contacts-tab"
          data-bs-toggle="pill"
          href="#v-pills-contacts"
          role="tab"
          aria-controls="v-pills-contacts"
          aria-selected="false"
        >
          <div class="left-menu-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M17.3667 3.51667C17.325 3.41667 17.275 3.325 17.2167 3.23333C17.1 3.05833 16.9417 2.9 16.7667 2.78333C16.675 2.725 16.5833 2.675 16.4833 2.63333C16.2833 2.55 16.0667 2.5 15.8333 2.5H15V0.833334H13.3333V2.5H6.66667V0.833334H5V2.5H4.16667C3.81667 2.5 3.5 2.60833 3.23333 2.78333C3.05833 2.9 2.9 3.05833 2.78333 3.23333C2.725 3.325 2.675 3.41667 2.63333 3.51667C2.55 3.71667 2.5 3.93333 2.5 4.16667V15.8333C2.5 16.2754 2.67559 16.6993 2.98816 17.0118C3.30072 17.3244 3.72464 17.5 4.16667 17.5H15.8333C16.0667 17.5 16.2833 17.45 16.4833 17.3667C16.5833 17.325 16.675 17.275 16.7667 17.2167C16.9417 17.1 17.1 16.9417 17.2167 16.7667C17.3917 16.5 17.5 16.175 17.5 15.8333V4.16667C17.5 3.93333 17.45 3.71667 17.3667 3.51667ZM4.16667 15.8333V4.16667H15.8333V15.8333H4.16667ZM10 10.7333C8.30833 10.7333 5 11.6333 5 13.7167V15H15V13.725C15 11.6333 11.6917 10.7333 10 10.7333ZM6.925 13.3333C7.5 12.8667 8.90833 12.4 10 12.4C11.0917 12.4 12.5083 12.8667 13.075 13.3333H6.925ZM10 10C11.375 10 12.5 8.875 12.5 7.5C12.5 6.125 11.375 5 10 5C8.625 5 7.5 6.125 7.5 7.5C7.5 8.875 8.625 10 10 10ZM10 6.66667C10.4583 6.66667 10.8333 7.04167 10.8333 7.5C10.8333 7.95833 10.4583 8.33333 10 8.33333C9.54167 8.33333 9.16667 7.95833 9.16667 7.5C9.16667 7.04167 9.54167 6.66667 10 6.66667Z"
                fill=""
              />
            </svg>
          </div>
          Client Contacts</a
        >
      </li>
      <li class={clientTypeError ? 'error' : ''}>
        <a
          class="nav-link rounded-start d-flex align-items-center"
          id="v-pills-client-tab"
          data-bs-toggle="pill"
          href="#v-pills-client"
          role="tab"
          aria-controls="v-pills-client"
          aria-selected="false"
        >
          <div class="left-menu-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.912 6.91L13.3287 10.4867L12.252 9.41L11.0737 10.5883L13.3287 12.8417L18.0887 8.09L16.912 6.91ZM3.33366 6.66667C3.33366 8.56667 4.76699 10 6.66699 10C8.56699 10 10.0003 8.56667 10.0003 6.66667C10.0003 4.76667 8.56699 3.33333 6.66699 3.33333C4.76699 3.33333 3.33366 4.76667 3.33366 6.66667ZM8.33366 6.66667C8.33366 7.64833 7.64866 8.33333 6.66699 8.33333C5.68533 8.33333 5.00033 7.64833 5.00033 6.66667C5.00033 5.685 5.68533 5 6.66699 5C7.64866 5 8.33366 5.685 8.33366 6.66667ZM3.33366 15C3.33366 13.6217 4.45533 12.5 5.83366 12.5H7.50033C8.87866 12.5 10.0003 13.6217 10.0003 15V15.8333H11.667V15C11.667 12.7025 9.79783 10.8333 7.50033 10.8333H5.83366C3.53616 10.8333 1.66699 12.7025 1.66699 15V15.8333H3.33366V15Z"
                fill=""
              />
            </svg>
          </div>
          Client Type *</a
        >
      </li>
      <li class={registrationTypeError ? 'error' : ''}>
        <a
          class="nav-link rounded-start d-flex align-items-center"
          id="v-pills-registration-tab"
          data-bs-toggle="pill"
          href="#v-pills-registration"
          role="tab"
          aria-controls="v-pills-registration"
          aria-selected="false"
        >
          <div class="left-menu-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              ><path
                d="M0 2.5V17.5H20V2.5H0ZM8.75 16.25H1.25V3.75H8.75V16.25ZM18.75 16.25H11.25V3.75H18.75V16.25Z"
              /><path
                d="M12.5 5H17.5V6.25H12.5V5Z"
                fill=""
              /><path d="M2.5 5H7.5V6.25H2.5V5Z" /><path
                d="M2.5 7.5H7.5V8.75H2.5V7.5Z"
                fill=""
              /><path d="M2.5 10H7.5V11.25H2.5V10Z" /></svg
            >
          </div>
          Registration Type *</a
        >
      </li>
      <li class={engagementTypeError ? 'error' : ''}>
        <a
          class="nav-link rounded-start d-flex align-items-center"
          id="v-pills-active-tab"
          data-bs-toggle="pill"
          href="#v-pills-active"
          role="tab"
          aria-controls="v-pills-active"
          aria-selected="false"
        >
          <div class="left-menu-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              ><path
                d="M12.5 10C12.5 10.663 12.2366 11.2989 11.7678 11.7678C11.2989 12.2366 10.663 12.5 10 12.5C9.33696 12.5 8.70107 12.2366 8.23223 11.7678C7.76339 11.2989 7.5 10.663 7.5 10C7.5 9.33696 7.76339 8.70107 8.23223 8.23223C8.70107 7.76339 9.33696 7.5 10 7.5C10.663 7.5 11.2989 7.76339 11.7678 8.23223C12.2366 8.70107 12.5 9.33696 12.5 10Z"
              /><path
                d="M18.125 8.9375L12.8 3.0125L11.6375 2.5H5.3125L3.75 4.0625V15.9125L5.3125 17.475H11.6375L12.8 16.95L18.125 11.025V8.9375ZM11.6375 15.9125H5.3125V4.0625H11.6375L16.9625 9.975L11.6375 15.9125Z"
              /></svg
            >
          </div>
          Engagement Type *
        </a>
      </li>
      <li class={usersError ? 'error' : ''}>
        <a
          class="nav-link d-flex align-items-center rounded-start"
          id="v-pills-users-tab"
          data-bs-toggle="pill"
          href="#v-pills-users"
          role="tab"
          aria-controls="v-pills-users"
          aria-selected="false"
        >
          <div class="left-menu-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              ><path
                d="M10.2497 10.1833C10.6943 9.79845 11.051 9.32241 11.2954 8.78752C11.5398 8.25264 11.6663 7.67143 11.6663 7.08334C11.6663 5.97827 11.2274 4.91846 10.446 4.13706C9.66455 3.35566 8.60474 2.91667 7.49967 2.91667C6.39461 2.91667 5.3348 3.35566 4.5534 4.13706C3.77199 4.91846 3.33301 5.97827 3.33301 7.08334C3.333 7.67143 3.45951 8.25264 3.70395 8.78752C3.94838 9.32241 4.30503 9.79845 4.74967 10.1833C3.58312 10.7116 2.5934 11.5646 1.89882 12.6405C1.20425 13.7163 0.834234 14.9694 0.833008 16.25C0.833008 16.471 0.920805 16.683 1.07709 16.8393C1.23337 16.9955 1.44533 17.0833 1.66634 17.0833C1.88735 17.0833 2.09932 16.9955 2.2556 16.8393C2.41188 16.683 2.49967 16.471 2.49967 16.25C2.49967 14.9239 3.02646 13.6522 3.96414 12.7145C4.90182 11.7768 6.17359 11.25 7.49967 11.25C8.82576 11.25 10.0975 11.7768 11.0352 12.7145C11.9729 13.6522 12.4997 14.9239 12.4997 16.25C12.4997 16.471 12.5875 16.683 12.7438 16.8393C12.9 16.9955 13.112 17.0833 13.333 17.0833C13.554 17.0833 13.766 16.9955 13.9223 16.8393C14.0785 16.683 14.1663 16.471 14.1663 16.25C14.1651 14.9694 13.7951 13.7163 13.1005 12.6405C12.406 11.5646 11.4162 10.7116 10.2497 10.1833ZM7.49967 9.58334C7.00522 9.58334 6.52187 9.43672 6.11075 9.16201C5.69963 8.88731 5.37919 8.49686 5.18998 8.04005C5.00076 7.58323 4.95125 7.08057 5.04771 6.59561C5.14417 6.11066 5.38228 5.6652 5.73191 5.31557C6.08154 4.96594 6.527 4.72784 7.01195 4.63138C7.4969 4.53491 7.99957 4.58442 8.45638 4.77364C8.9132 4.96286 9.30364 5.28329 9.57835 5.69441C9.85305 6.10554 9.99967 6.58889 9.99967 7.08334C9.99967 7.74638 9.73628 8.38227 9.26744 8.85111C8.7986 9.31995 8.16272 9.58334 7.49967 9.58334ZM15.6163 9.85001C16.1496 9.24945 16.498 8.50755 16.6195 7.71362C16.741 6.91969 16.6304 6.10757 16.3011 5.37501C15.9718 4.64244 15.4378 4.02067 14.7634 3.58452C14.089 3.14838 13.3028 2.91646 12.4997 2.91667C12.2787 2.91667 12.0667 3.00447 11.9104 3.16075C11.7541 3.31703 11.6663 3.52899 11.6663 3.75001C11.6663 3.97102 11.7541 4.18298 11.9104 4.33926C12.0667 4.49554 12.2787 4.58334 12.4997 4.58334C13.1627 4.58334 13.7986 4.84673 14.2674 5.31557C14.7363 5.78441 14.9997 6.4203 14.9997 7.08334C14.9985 7.52104 14.8824 7.95076 14.6631 8.32952C14.4437 8.70829 14.1287 9.02282 13.7497 9.24167C13.6261 9.31294 13.5229 9.41473 13.45 9.53729C13.377 9.65985 13.3367 9.79909 13.333 9.94167C13.3295 10.0831 13.3621 10.2232 13.4277 10.3486C13.4933 10.4739 13.5898 10.5806 13.708 10.6583L14.033 10.875L14.1413 10.9333C15.1458 11.4098 15.9933 12.1633 16.5838 13.1053C17.1744 14.0472 17.4835 15.1383 17.4747 16.25C17.4747 16.471 17.5625 16.683 17.7188 16.8393C17.875 16.9955 18.087 17.0833 18.308 17.0833C18.529 17.0833 18.741 16.9955 18.8973 16.8393C19.0535 16.683 19.1413 16.471 19.1413 16.25C19.1482 14.9712 18.8279 13.7119 18.2109 12.5917C17.5939 11.4716 16.7008 10.5278 15.6163 9.85001Z"
                fill=""
              /></svg
            >
          </div>
          Staff Assignments *
        </a>
      </li>
      <li class={attachmentError ? 'error' : ''}>
        <a
          class="nav-link rounded-start d-flex align-items-center"
          id="v-pills-link-attach-tab"
          data-bs-toggle="pill"
          href="#v-pills-link-attach"
          role="tab"
          aria-controls="v-pills-link-attach"
          aria-selected="false"
        >
          <div class="left-menu-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              ><path
                d="M3.5181 16.4817C3.90466 16.8688 4.3639 17.1757 4.86945 17.3848C5.37499 17.5939 5.91686 17.701 6.46393 17.7C7.01112 17.701 7.55311 17.5938 8.05879 17.3847C8.56446 17.1757 9.02386 16.8688 9.4106 16.4817L11.7673 14.1242L10.5889 12.9458L8.23226 15.3033C7.76266 15.7708 7.12699 16.0333 6.46435 16.0333C5.80171 16.0333 5.16604 15.7708 4.69643 15.3033C4.22852 14.8339 3.96577 14.1982 3.96577 13.5354C3.96577 12.8726 4.22852 12.2369 4.69643 11.7675L7.05393 9.41083L5.8756 8.23249L3.5181 10.5892C2.73794 11.3712 2.2998 12.4308 2.2998 13.5354C2.2998 14.6401 2.73794 15.6996 3.5181 16.4817ZM16.4814 9.41083C17.2612 8.62856 17.699 7.56909 17.699 6.46458C17.699 5.36006 17.2612 4.30059 16.4814 3.51833C15.6994 2.73817 14.6398 2.30003 13.5352 2.30003C12.4305 2.30003 11.371 2.73817 10.5889 3.51833L8.23226 5.87583L9.4106 7.05416L11.7673 4.69666C12.2369 4.22915 12.8725 3.96668 13.5352 3.96668C14.1978 3.96668 14.8335 4.22915 15.3031 4.69666C15.771 5.16605 16.0338 5.8018 16.0338 6.46458C16.0338 7.12735 15.771 7.7631 15.3031 8.23249L12.9456 10.5892L14.1239 11.7675L16.4814 9.41083Z"
              /><path
                d="M7.05319 14.125L5.87402 12.9467L12.9465 5.875L14.1249 7.05417L7.05319 14.125Z"
                fill=""
              /></svg
            >
          </div>
          Links/Attachments
        </a>
      </li>
      <li class={fundProfileError ? 'error' : ''}>
        <a
          class="nav-link rounded-start d-flex align-items-center"
          id="v-pills-fund-profile-tab"
          data-bs-toggle="pill"
          href="#v-pills-fund-profile"
          role="tab"
          aria-controls="v-pills-fund-profile"
          aria-selected="false"
        >
          <div class="left-menu-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              ><path
                d="M3.672 12.1025L6.507 9.26749L8.86367 11.625L11.4945 8.99416L10.0003 7.49999H14.167V11.6667L12.6728 10.1725L8.86367 13.9817L6.507 11.625L4.4445 13.6867C5.38068 15.0957 6.81752 16.0962 8.46386 16.4853C10.1102 16.8744 11.8429 16.6231 13.3108 15.7822C14.7788 14.9414 15.8722 13.574 16.3694 11.957C16.8667 10.34 16.7307 8.5945 15.9889 7.0741C15.2471 5.55371 13.955 4.37218 12.3745 3.76894C10.794 3.16571 9.04333 3.18588 7.47715 3.82538C5.91098 4.46488 4.6465 5.67587 3.93994 7.21295C3.23338 8.75004 3.1376 10.4982 3.672 12.1033V12.1025ZM2.39033 13.4008L2.382 13.3925L2.38533 13.3892C1.91027 12.3225 1.6655 11.1677 1.667 9.99999C1.667 5.39749 5.39783 1.66666 10.0003 1.66666C14.6028 1.66666 18.3337 5.39749 18.3337 9.99999C18.3337 14.6025 14.6028 18.3333 10.0003 18.3333C6.60867 18.3333 3.692 16.3083 2.39033 13.4008Z"
                fill=""
              /></svg
            >
          </div>
          Fund Profile
        </a>
      </li>
      <li class={otherInfoError ? 'error' : ''}>
        <a
          class="nav-link rounded-start d-flex align-items-center"
          id="v-pills-other-info-tab"
          data-bs-toggle="pill"
          href="#v-pills-other-info"
          role="tab"
          aria-controls="v-pills-other-info"
          aria-selected="false"
        >
          <div class="left-menu-icon">
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              ><path
                d="M10.8333 13.3333H10V10H9.16667L10.8333 13.3333ZM10 6.66667H10.0083H10ZM17.5 10C17.5 10.9849 17.306 11.9602 16.9291 12.8701C16.5522 13.7801 15.9997 14.6069 15.3033 15.3033C14.6069 15.9997 13.7801 16.5522 12.8701 16.9291C11.9602 17.306 10.9849 17.5 10 17.5C9.01509 17.5 8.03982 17.306 7.12987 16.9291C6.21993 16.5522 5.39314 15.9997 4.6967 15.3033C4.00026 14.6069 3.44781 13.7801 3.0709 12.8701C2.69399 11.9602 2.5 10.9849 2.5 10C2.5 8.01088 3.29018 6.10322 4.6967 4.6967C6.10322 3.29018 8.01088 2.5 10 2.5C11.9891 2.5 13.8968 3.29018 15.3033 4.6967C16.7098 6.10322 17.5 8.01088 17.5 10Z"
                stroke=""
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              /></svg
            >
          </div>
          Other Information
        </a>
      </li>
      {#if !selectUnitsInfo.outsourcedCfo}
        <li class={serviceProviderError ? 'error' : ''}>
          <a
            class="nav-link rounded-start d-flex align-items-center"
            id="v-pills-service-provider-tab"
            data-bs-toggle="pill"
            href="#v-pills-service-provider"
            role="tab"
            aria-controls="v-pills-service-provider"
            aria-selected="false"
          >
            <div class="left-menu-icon">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                ><path
                  d="M16.667 6.66668H14.167V5.00001C14.167 4.08334 13.417 3.33334 12.5003 3.33334H7.50033C6.58366 3.33334 5.83366 4.08334 5.83366 5.00001V6.66668H3.33366C2.41699 6.66668 1.66699 7.41668 1.66699 8.33334V16.6667H18.3337V8.33334C18.3337 7.41668 17.5837 6.66668 16.667 6.66668ZM7.50033 5.00001H12.5003V6.66668H7.50033V5.00001ZM16.667 15H3.33366V12.5H5.00033V13.3333H6.66699V12.5H13.3337V13.3333H15.0003V12.5H16.667V15ZM15.0003 10.8333V10H13.3337V10.8333H6.66699V10H5.00033V10.8333H3.33366V8.33334H16.667V10.8333H15.0003Z"
                  fill=""
                /></svg
              >
            </div>
            Service Provider Contacts</a
          >
        </li>
      {/if}
    </ul>
  </div>
</div>

<style lang="scss">
  .add-client-left {
    flex: 0 0 300px;
    max-width: 300px;
    min-width: 300px;
    background: rgba(205, 217, 233, 0.1);
    ul {
      border-left: 1px solid $input-border-color;
      list-style: none;
      padding: 0px 0px 0px 3px;
      margin-left: 15px;
      li {
        width: 100%;
        .left-menu-icon {
          width: 30px;
          height: 20px;
        }
        a {
          color: $lead-color;
          position: relative;
          svg {
            fill: $black-color;
          }
          &.active {
            background: transparent;
            color: $blue-color;
            position: relative;
            svg {
              fill: $blue-color;
            }
            &:before {
              position: absolute;
              left: -16px;
              top: 0px;
              width: 24px;
              height: 24px;
              border: 4px solid $input-border-color;
              content: '';
              border-radius: 50%;
              background: $blue-color;
              top: 5px;
            }
          }
        }
        &.error {
          a {
            color: $red-color;
            svg {
              fill: $red-color;
            }
          }
        }
      }
    }
  }
</style>
